import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { FaPlus, FaEdit } from 'react-icons/fa';
import AddEditMappingModal from './AddEditMappingModal';
import DeleteSpecialtyMapping from './DeleteSpecialtyMapping';

const MappingsTab = ({ mappings }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedMapping, setSelectedMapping] = useState(null);

  const toggleModal = () => setModalOpen(!modalOpen);

  const openAdd = () => {
    setIsEdit(false);
    setSelectedMapping(null);
    setModalOpen(true);
  };

  const openEdit = mapping => {
    setIsEdit(true);
    setSelectedMapping(mapping);
    setModalOpen(true);
  };

  return (
    <div className="mapping-wrapper">
      <div className="mapping-header-row">
        <div className="mapping-table">
          <div className="mapping-header">
            <div className="cell header-cell">AMS Specialty</div>
            <div className="cell header-cell">App Category</div>
            <div className="cell header-cell">Actions</div>
          </div>
        </div>

        <Button className="add-mapping-btn" onClick={openAdd}>
          <FaPlus className="add-icon" />
          Add New Mapping
        </Button>
      </div>

      {mappings.map(row => (
        <div className="mapping-row" key={row.id}>
          <div className="cell">{row.specialization}</div>

          <div className="cell">{row.specialty}</div>

          <div className="cell actions">
            <span className="edit" onClick={() => openEdit(row)}>
              <FaEdit />
              Edit
            </span>

            <DeleteSpecialtyMapping specialization={row.specialization} />
          </div>
        </div>
      ))}

      <AddEditMappingModal
        isOpen={modalOpen}
        toggle={toggleModal}
        isEdit={isEdit}
        mapping={selectedMapping}
        mappings={mappings}
      />
    </div>
  );
};

MappingsTab.propTypes = {
  mappings: PropTypes.array
};

export default MappingsTab;
